module.exports = __webpack_public_path__ + "img/project2_small@2x.531a20ec.webp";